var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    width: 10,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0f;\n        opacity: 0;\n      }\n\n      .cls-2 {\n        fill: #ffffff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron",
    transform: "translate(8) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    className: "cls-1",
    width: 10,
    height: 6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M10,1A1,1,0,0,0,8.293.293L5,3.586,1.707.293A1,1,0,1,0,.293,1.707l4,4a1,1,0,0,0,1.415,0l4-4A1,1,0,0,0,10,1Z",
    transform: "translate(2 8) rotate(-90)",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.8146fa3696e2f27cf4958e9c9cd7550b.svg";
export { ForwardRef as ReactComponent };